export default __webpack_public_path__ + "static/media/circle_hackning.7b20d322.png";